<script lang="ts">
  import { goto } from '$app/navigation';
  import { createClass } from '$lib/api/classes';
  import ClassEditor from '$lib/components/classes/ClassEditor.svelte';
</script>

<main class="container-fluid py-3" id="main-content">
  <h2>New Class</h2>
  <div class="card">
    <div class="card-body">
      <ClassEditor
        onSave={async clazz => {
          const createdClass = await createClass(clazz);
          goto(`/admin/classes/${createdClass.id}`);
        }}
      />
    </div>
  </div>
</main>
